var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { Grid, Field, withGraphqlErrorFlags, withLoadingSpinner, withShowFlag, GridColumn, Link, PageLayout, displayUserInfo, userUrl, compose, graphql, isSufficientPermission, Permission, } from "@atlassiansox/microscopekit";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import serviceQuery from "./service-query.query.graphql";
import updateAZDRMutation from "./update-azdr.mutation.graphql";
import { ModifyAZDRChampionForm } from "../components";
var AZDRView = /** @class */ (function (_super) {
    __extends(AZDRView, _super);
    function AZDRView(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document.title = this.props.data.service.id + " | AZ DR";
                        return [4 /*yield*/, fetch("https://statlas.prod.atl-paas.net/dr/azdrDetails.json")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        this.setState({ azdr: json.azdrOutput, isLoaded: true });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            azdr: JSON,
            isLoaded: false,
        };
        return _this;
    }
    AZDRView.prototype.render = function () {
        var _a, _b, _c, _d;
        var service = this.props.data.service;
        var drChampion1 = (_b = (_a = service.attributes.azdrAttribute) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.drChampion1;
        var drChampion2 = (_d = (_c = service.attributes.azdrAttribute) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.drChampion2;
        var AZDRButton = (React.createElement(ModifyAZDRChampionForm, { primary: drChampion1 === null || drChampion1 === void 0 ? void 0 : drChampion1.id, secondary: drChampion2 === null || drChampion2 === void 0 ? void 0 : drChampion2.id, data: this.props.data, updateService: this.props.updateService }));
        var drChampion1Details;
        var drChampion2Details;
        if (drChampion1) {
            try {
                if (drChampion1.displayName) {
                    drChampion1Details = (React.createElement(Link, { to: userUrl(drChampion1.id) }, displayUserInfo(drChampion1)));
                }
                else {
                    drChampion1Details = (React.createElement(Link, { to: userUrl(drChampion1.id) },
                        "Unknown User (",
                        drChampion1.id,
                        ")"));
                }
            }
            catch (e) {
                drChampion1Details = 'Failed to get Details for DR Champion';
            }
        }
        else {
            drChampion1Details = 'Not specified';
        }
        if (drChampion2) {
            try {
                if (drChampion2.displayName) {
                    drChampion2Details = (React.createElement(Link, { to: userUrl(drChampion2.id) }, displayUserInfo(drChampion2)));
                }
                else {
                    drChampion2Details = (React.createElement(Link, { to: userUrl(drChampion2.id) },
                        "Unknown User (",
                        drChampion2.id,
                        ")"));
                }
            }
            catch (e) {
                drChampion2Details = 'Failed to get Details for DR Champion';
            }
        }
        else {
            drChampion2Details = 'Not specified';
        }
        var azdr = this.state.azdr;
        if (!this.state.isLoaded) {
            // remove below line if we can't read from local file and uncomment return
            // azdr = require('../../azdrDetails.json').azdrOutput;
            return (React.createElement(PageLayout, { title: "AZ Disaster Recovery" }));
        }
        var title = "AZ Disaster Recovery - " + azdr.name;
        return (React.createElement(PageLayout, { title: title },
            isSufficientPermission(service.currentUserPermission, Permission.Write) ? (AZDRButton) : undefined,
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(Field, { name: "blogPost", label: "Blog Post" }, function () {
                        return React.createElement("div", null,
                            React.createElement(Link, { to: "" + azdr.blogLink, title: "Confluence Link" }));
                    }),
                    React.createElement(Field, { name: "slackRoom", label: "Slack" }, function () {
                        return React.createElement("div", null,
                            React.createElement(Link, { to: "" + azdr.slackRoomLink, title: "Room Link" }));
                    }),
                    React.createElement(Field, { name: "stagingSchedule", label: "Staging Details" }, function () {
                        return React.createElement("div", null,
                            React.createElement("div", null, azdr.staging.schedule),
                            React.createElement("div", null,
                                React.createElement(Link, { to: "" + azdr.staging.calendarInviteLink, title: "Calendar Invite" }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.staging.zoomLink, title: "\nZoom" }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.staging.trelloBoardLink, title: "\nTrello Board" }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.staging.statusPageLink, title: "Status Page" }),
                                React.createElement("br", null)));
                    }),
                    React.createElement(Field, { name: "prodSchedule", label: "Prod Details" }, function () {
                        return React.createElement("div", null,
                            React.createElement("div", null, azdr.prod.schedule),
                            React.createElement("div", null,
                                React.createElement(Link, { to: "" + azdr.prod.calendarInviteLink, title: "Calendar Invite " }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.prod.zoomLink, title: "Zoom" }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.prod.trelloBoardLink, title: "Trello Board" }),
                                React.createElement("br", null),
                                React.createElement(Link, { to: "" + azdr.prod.statusPageLink, title: "Status Page" }),
                                React.createElement("br", null)));
                    })),
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(Field, { name: "drChampion1", label: "DR Champion 1" }, function () {
                        return React.createElement("div", null, drChampion1Details);
                    }),
                    React.createElement(Field, { name: "drChampion2", label: "DR Champion 2" }, function () {
                        return React.createElement("div", null, drChampion2Details);
                    }),
                    React.createElement(Field, { name: "testExecutor", label: "Test Executor" }, function () {
                        return React.createElement("div", null,
                            React.createElement(Link, { to: userUrl(azdr.testExecutor.username) },
                                azdr.testExecutor.name,
                                " ",
                                displayUserInfo(azdr.testExecutor)));
                    }),
                    React.createElement(Field, { name: "testCoordinator", label: "Test Co-ordinator" }, function () {
                        return React.createElement("div", null,
                            React.createElement(Link, { to: userUrl(azdr.testCoordinator.username) },
                                azdr.testCoordinator.name,
                                " ",
                                displayUserInfo(azdr.testCoordinator)));
                    })))));
    };
    return AZDRView;
}(React.Component));
export { AZDRView };
export var AZDRPage = compose(graphql(serviceQuery, { options: { errorPolicy: 'ignore' } }), graphql(updateAZDRMutation, {
    name: "updateService"
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler)(AZDRView);
